import InlineSelection from '@anm/components/list/InlineSelection';
import { useCallback, useState, FC } from 'react';
import { useSelector } from 'react-redux';

import { hostedVideoSelectors } from '../../../../../../store/modules/hostedVideo';
import PlayButtonCheckbox from '../../../PlayButtonCheckbox';
import { SectionSubTitle } from '../../../Wrapper';
import EmbedSizes from '../EmbedSizes';

import TextField from './TextField';
import { SelectionWrapper, Wrapper } from './Wrapper';
import { useUpdatePopover } from './hooks';

type PopoverEmbedProps = {};

export const THUMBNAIL_INDEX = 0;
export const HIGHLIGHT_INDEX = 1;
export const TEXT_LINK_INDEX = 2;

export type PopoverTypeIndexes =
  | typeof THUMBNAIL_INDEX
  | typeof HIGHLIGHT_INDEX
  | typeof TEXT_LINK_INDEX;

const POPOVER_TYPES_LIST = ['Thumbnail', 'Highlight', 'Text link'];

const PopoverEmbed: FC<PopoverEmbedProps> = () => {
  const [activePopoverType, setActivePopoverType] = useState(THUMBNAIL_INDEX);

  const playButtonInitialStatus = useSelector(
    hostedVideoSelectors.selectThumbnailEmbedButtonStatus
  );

  const [playButtonStatus, setPlayButtonStatus] = useState(
    typeof playButtonInitialStatus === 'undefined'
      ? true
      : playButtonInitialStatus
  );

  useUpdatePopover({
    playButtonStatus,
    activePopoverType: activePopoverType as PopoverTypeIndexes
  });

  const handleCheckboxChange = useCallback(
    () => setPlayButtonStatus(playButtonStatus => !playButtonStatus),
    []
  );

  const isThumbnail = activePopoverType === THUMBNAIL_INDEX;

  return (
    <Wrapper>
      <SectionSubTitle title="Popover link type" level={4} />
      <SelectionWrapper>
        <InlineSelection
          list={POPOVER_TYPES_LIST}
          activeItem={activePopoverType}
          onChange={setActivePopoverType}
        />
      </SelectionWrapper>
      {isThumbnail ? (
        <>
          <PlayButtonCheckbox
            isChecked={playButtonStatus}
            onCheckBoxChange={handleCheckboxChange}
          />
          <EmbedSizes title="Thumbnail size" />
        </>
      ) : (
        <TextField
          activePopoverType={activePopoverType as PopoverTypeIndexes}
        />
      )}
    </Wrapper>
  );
};

export default PopoverEmbed;
